
let pointKey = 'saas_app_point';

// 设置从dialog弹框跳转到绑定支付宝页面
export function getPoint() {
  return sessionStorage.getItem(pointKey);
}

export function setPoint(value) {
  return sessionStorage.setItem(pointKey, value);
}

export function removePoint() {
  return sessionStorage.removeItem(pointKey);
}